module.exports = __webpack_public_path__ + "052787b08233d85edebfc4ce4610944e.mp4";